(ns teamoesterreich.admin-mode.selection.selection-list
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.selection.selection-table :as table]
            [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [teamoesterreich.admin-mode.modal.send-message-modal :as send-message-modal]
            [teamoesterreich.admin-mode.modal.info-modal :as info-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            ))

(defn event-value
  [^js/Event e]
  (h/event-value e))

(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn get-sort-filter-rows [rows sort_ reverse_ filter_]
  (js/console.log "res = " rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (filter-fn rows filter_)
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))






(defn table-column [!st !selected]
  (let [
        rows (get-sort-filter-rows @!selected (:sort @!st) (:reverse @!st) (:search @!st))
        cnt-rows (count rows)]

    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))


(defn get-it []
  (let [!st (r/atom {:sort :user-lastName :reverse true :search "" :show-create-list false :waiting false})
        !search (r/cursor !st [:search])
        !waiting? (r/cursor !st [:waiting])
        !map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup]) ;;steffen

        !show-intoEvent-confirm? (r/cursor !st [:show-intoEvent-confirm])
        !show-intoTraining-confirm? (r/cursor !st [:show-intoTraining-confirm])
        !show-intoCanYou-confirm? (r/cursor !st [:show-intoCanYou-confirm])

        !show-create-list (r/cursor !st [:show-create-list])
        !show-delete-list? (r/cursor !st [:show-delete-list])
        !actual-user (r/cursor vstate/app-state [:actual-user])
        !selectionLists (r/cursor vstate/app-state [:selected-elements :lists])
        !selectionLists-loaded (r/cursor vstate/app-state [:selected-elements :lists-loaded])
        !selected (r/cursor vstate/app-state [:selected-elements :selected])
        !selection-loaded (r/cursor vstate/app-state [:selected-elements :loaded])
        !selection-uuid (r/cursor vstate/app-state [:selected-elements :list-uuid])

        !show-send-email (r/cursor !st [:show-send-email])
        !show-send-sms (r/cursor !st [:show-send-sms])
        !show-message-sent (r/cursor !st [:show-sent])

        !selected-event (r/cursor vstate/app-state [:selected-event])
        !selected-training (r/cursor vstate/app-state [:selected-training])
        !selected-canyou (r/cursor vstate/app-state [:selected-canyou])
        event-allow-add (and @!selected-event (or (= (:crowdtaskerEvent-category @!selected-event) "ONLINE")
                                                  (not (:crowdtaskerEvent-status @!selected-event))
                                                  (= (:crowdtaskerEvent-status @!selected-event) "created")
                                                  (= (:crowdtaskerEvent-status @!selected-event) "running")
                                                  (= (:crowdtaskerEvent-status @!selected-event) "waitAccept")
                                                  (= (:crowdtaskerEvent-status @!selected-event) "collecting")))

        canyou-allow-add (and @!selected-canyou (or (not (:crowdtaskerEvent-status @!selected-canyou))
                                                    (= (:crowdtaskerEvent-status @!selected-canyou) "created")
                                                    (= (:crowdtaskerEvent-status @!selected-canyou) "running")
                                                    (= (:crowdtaskerEvent-status @!selected-canyou) "waitAccept")
                                                    (= (:crowdtaskerEvent-status @!selected-canyou) "collecting")))





        training-allow-add (and @!selected-training (or (not (:trainingEvent-status @!selected-training)) (= (:trainingEvent-status @!selected-training) "created") (= (:trainingEvent-status @!selected-training) "waitAccept") (= (:trainingEvent-status @!selected-training) "collecting")))

        tomId (:tom-id @!actual-user)]

    (fn []
      (let [cntSel (if @!selected (count (filter second @!selected)))
            tomIds (mapv (fn [[k v]] (:user-tomId v)) @!selected)]
        (if-not (and @!selectionLists-loaded @!selection-uuid)
          (do
            (d-webSelection/get-selections tomId
                                           (fn [response]
                                             (log/debug "get-selections " response @!selection-uuid)
                                             (reset! !selectionLists response)
                                             (reset! !selectionLists-loaded true)
                                             (if (empty? response) (d-webSelection/create-first-list tomId (fn [e]
                                                                                                             (js/console.log e))))
                                             (when-not @!selection-uuid
                                               (log/debug "set-selection-uuid to first " (ffirst response))
                                               (reset! !selection-uuid (ffirst response)))
                                             ))
            [mui/paper
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )
          [mui/paper {:style {:marginTop "5px" :padding "10px"}}

           [info-modal/info-modal !show-message-sent "Diese Nachricht wurde gesendet!" "Ok"]
           [(send-message-modal/email-template-modal !show-send-email "user" (str "Email erstellen und an " cntSel " Personen senden:") "senden"
                                                     (fn [subject email from] (d-webSelection/email-to-list @!selection-uuid subject email from #(reset! !show-message-sent true)))
                                                     nil
                                                     (fn [subject email from] (d-webSelection/email-to-list @!selection-uuid subject email from #(reset! !show-message-sent true) :self)))]

           [(send-message-modal/sms-modal !show-send-sms (str "SMS erstellen und an " cntSel " Personen senden:") "senden" ;;todo template
                                          (fn [message] (d-webSelection/sms-to-list @!selection-uuid message #(reset! !show-message-sent true))))]

           (log/debug "tomIds " tomIds)
           [mui/grid
            {:container  true
             :direction  "row"
             :alignItems "stretch"
             :justify    "flex-start"
             :style      {:height "calc(100% - 64px)" :minHeight "600px"}
             }

            (log/debug "selected-event " (:crowdtaskerEvent-name @!selected-event))
            [are-you-sure-modal/are-you-sure-modal !show-delete-list?
             (str "Willst du wirklich diese Auswahl-Liste löschen ? ")
             "Löschen"
             (fn [] (d-webSelection/>drop-list @!selection-uuid #(reset! !selection-uuid nil)))
             ]
            [are-you-sure-modal/are-you-sure-modal !show-intoEvent-confirm?
             (str "Willst du wirklich diese Auswahl in den aktuellen Einsatz \"" (:crowdtaskerEvent-name @!selected-event) "\" übernehmen ?: ")
             "Übernehmen"
             (fn []
               (d-webSelection/add-to-event-member @!selection-uuid (:crowdtaskerEvent-uuid @!selected-event)
                                                   #(swap! vstate/app-state assoc :event-detail-loaded false)))
             ]
            [are-you-sure-modal/are-you-sure-modal !show-intoCanYou-confirm?
             (str "Willst du wirklich diese Auswahl in die aktuelle Anfrage \"" (:crowdtaskerEvent-name @!selected-canyou) "\" übernehmen ?: ")
             "Übernehmen"
             (fn []
               (d-webSelection/add-to-event-member @!selection-uuid (:crowdtaskerEvent-uuid @!selected-canyou)
                                                   #(swap! vstate/app-state assoc :event-detail-loaded false)))
             ]
            [are-you-sure-modal/are-you-sure-modal !show-intoTraining-confirm?
             (str "Willst du wirklich diese Auswahl in den aktuelle Veranstaltung \"" (:trainingEvent-name @!selected-training) "\" übernehmen ?: ")
             "Übernehmen"
             (fn []
               (d-webSelection/add-to-training-member @!selection-uuid (:trainingEvent-uuid @!selected-training)
                                                      #(swap! vstate/app-state assoc :trainingEvent-detail-loaded false)))
             ]
            [toe-modal/get-modal !map-userPopup]
            [mui/grid
             {:item  true
              :lg    12
              :xs    12
              :style {:textAlign "left"}}
             [create-with-name-modal/modal
              !show-create-list
              "Neue Auswahl erstellen. Bitte Namen eingeben:"
              "Anlegen"
              (fn [name] (d-webSelection/>create-list tomId name
                                                      (fn [data]
                                                        (log/debug "XXX created-list" (:webUserSelection-uuid data))
                                                        (reset! !selection-uuid (:webUserSelection-uuid data))
                                                        (reset! !selectionLists-loaded false)
                                                        (reset! !selection-loaded false))))]
             [:h3 "Aktuelle Auswahl (" cntSel " Personen)"]


             ;(log/debug "!selectionLists" @!selectionLists)
             [mui/select
              {:multiple false
               :value    @!selection-uuid
               :style    {:minWidth "250px"}
               :onChange (fn [e]
                           (log/debug "set list: " (h/event-value e))
                           (reset! !selection-uuid (h/event-value e))
                           (reset! !selection-loaded false)
                           )
               }

              (for [[uuid {active :webUserSelection-active name :webUserSelection-name user :webUserSelection-user}] @!selectionLists]
                ^{:key (str "webUserSelection-" uuid)}
                [mui/menu-item {:value uuid} (str name " (" (or user 0) ")")])
              ]

             [mui/button {:variant   "outlined"
                          :style     {:margin-left "5px" :margin-right "25px"}
                          :startIcon (r/as-element [delete-outline])
                          :onClick   (fn []
                                       (d-webSelection/empty-list @!selection-uuid
                                                                  (fn [] (reset! !selectionLists-loaded false) (reset! !selection-loaded false))))
                          } "Liste leeren"]

             [mui/button {:variant   "outlined"
                          :startIcon (r/as-element [add])
                          :onClick   #(reset! !show-create-list true)
                          :style     {:margin-left "5px" :margin-right "5px"}} "Neue Liste"]

             [mui/button {:variant   "outlined"
                          :startIcon (r/as-element [delete-forever])
                          :onClick   #(reset! !show-delete-list? true)
                          :style     {:margin-right "25px"}} "Liste löschen"]

             (when (or
                     (d-rights/allow-admin-for d-rights/CROWDTASKER)
                     (d-rights/allow-admin-for d-rights/CLASSIC))
               [mui/button {:variant  "outlined"
                            :disabled (not event-allow-add)
                            :onClick  #(reset! !show-intoEvent-confirm? true)
                            :style    {:margin-left "15px"}} "In Einsatz übernehmen"])

             (when (d-rights/allow-admin-for d-rights/CANYOU)
               [mui/button {:variant  "outlined"
                            :disabled (not canyou-allow-add)
                            :onClick  #(reset! !show-intoCanYou-confirm? true)
                            :style    {:margin-left "15px"}} "In Kannst-Du übernehmen"])

             (when (d-rights/allow-admin-for d-rights/TRAINING)
               [mui/button {:variant  "outlined"
                            :disabled (not training-allow-add)
                            :onClick  #(reset! !show-intoTraining-confirm? true)
                            :style    {:margin-left "5px"}} "In Veranstaltung übernehmen"])

             [mui/button {:variant  "outlined"
                          :disabled (< cntSel 1)
                          :onClick  #(d-user/get-csv @!selection-uuid)
                          :style    {:margin-left "5px"}} "CSV Export"]


             [mui/button {:variant  "outlined"
                          :disabled (< cntSel 1)
                          :onClick  #(reset! !show-send-email true)
                          :style    {:margin-left "5px"}} "Email an Liste"]

             [mui/button {:variant  "outlined"
                          :disabled (< cntSel 1)
                          :onClick  #(reset! !show-send-sms true)
                          :style    {:margin-left "5px"}} "SMS/Push an Liste"]

             [ws-event-sync-component/ws-event-reload !selectionLists-loaded :webUserSelection]

             ]
            [mui/grid
             {:item  true
              :lg    12
              :xs    12
              :style {:textAlign "left"}}
             [mui/text-field
              {:default-value (str @!search)
               :placeholder   "Suche in Liste ..."
               :style         {:width "250px" :display "inline-block"}
               :onChange      (h/wait-do !waiting? #(reset! !search %))
               :multiline     false}]
             (log/debug "Search " @!search)
             (when false                                    ; (> (count @!search) 0)
               [mui/button {:variant   "outlined"
                            :startIcon (r/as-element [close])
                            :onClick   (h/wait-do !waiting? (fn [_] (reset! !search "")))
                            :style     {:margin-left "5px" :margin-right "25px"}} ""])
             ]

            (if-not @!selection-loaded
              (do
                (d-webSelection/get-user @!selection-uuid
                                         (fn [response]
                                           (reset! !selected response)
                                           (reset! !selection-loaded true)
                                           ))
                [mui/grid
                 {:item  true
                  :lg    12
                  :xs    12
                  :style {:height "calc(100% - 145px)"}
                  }
                 [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
                 [mui/typography {} "Lade Daten ... "]
                 ]
                )

              [mui/grid
               {:item  true
                :lg    12
                :xs    12
                :style {:height "calc(100% - 145px)"}
                }
               [table-column !st !selected]
               ])
            ]])))))

























